<template>
  <div
    :style="{ width: width, height: height }"
    class="echartsPie"
    ref="echartsPie"
  ></div>
</template>

<script>
import * as echarts from "echarts";
import {
  addResizeListener,
  removeResizeListener,
} from "element-ui/src/utils/resize-event";

export default {
  name: "echrts-pie",
  props: {
    // 宽
    width: {
      type: [Number, String],
      default: "100%",
    },
    // 高度
    height: {
      type: [Number, String],
      default: "100%",
    },
    zxs: {
      type: Number,
      default: 0,
    },
    // 数据
    data: {
      type: [Array, Object],
      default: () => [],
    },
  },
  data() {
    return {
      myChart: null,
    };
  },
  methods: {
    init() {
      let that = this;
      this.myChart = echarts.init(this.$refs["echartsPie"]);
      let option = {
        title: {
          text: `{value|${this.zxs}} {name|${this.$t(
            "bigScreen.台"
          )}} \n {name|${this.$t("bigScreen.在线设备数")}}`,
          left: "13%",
          top: "center",
          textStyle: {
            rich: {
              name: {
                fontFamily: "Roboto",
                fontSize: 16,
                color: "#fff",
                align: "center",
              },
              value: {
                fontSize: 40,
                color: "#fff",
                align: "center",
              },
            },
          },
        },
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(9, 24, 48, 0.8)",
          borderColor: "rgba(75, 253, 238, 0.6)",
          textStyle: {
            color: "#fff",
            fontSize: 16,
          },
          formatter: (params) => {
            return `${this.$t("bigScreen." + params.name)}: ${params.value}`;
          },
        },
        legend: {
          show: true,
          orient: "vertical",
          icon: "square",
          top: "30%",
          right: "10%",
          itemGap: 24,
          textStyle: {
            color: "#fff",
            fontSize: 16,
          },
          formatter: (name) => {
            let result = this.data.find((item) => item.name == name);
            return `${this.$t("bigScreen." + result.name)}： ${result.value}`;
          },
        },
        series: [
          {
            type: "pie",
            padAngle: 3,
            radius: ["80%", "95%"],
            center: ["25%", "50%"],
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            data: that.data,
          },
          {
            type: "pie",
            radius: ["70%", "72%"],
            center: ["25%", "50%"],
            hoverAnimation: false,
            tooltip: {
              show: false,
            },
            itemStyle: {
              color: "rgba(255,255,255,0.2)",
            },
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            data: [0],
          },
        ],
      };
      this.myChart.setOption(option);
      window.addEventListener("resize", () => {
        this.myChart.resize(); //当浏览器窗口大小发生变化时，图表可以进行自适应
      });
    },
    getDom() {
      return this.$refs["echartsPie"];
    },
  },
  watch: {
    data: {
      handler() {
        this.$nextTick(() => {
          this.init();
          addResizeListener(this.getDom(), this.myChart?.resize);
        });
      },
      deep: true,
    },
    "$i18n.locale": {
      handler() {
        this.$nextTick(() => {
          // 重新初始化图表以更新语言
          this.init();
        });
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      addResizeListener(this.getDom(), this.myChart?.resize);
    });
  },
  beforeDestroy() {
    removeResizeListener(this.getDom(), this.myChart?.resize);
    this.myChart && this.myChart.dispose();
  },
};
</script>

<style scoped></style>
